"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

var _conversation = require("../store/reducers/conversation");

var _conversation2 = require("../store/selectors/conversation");

var _traffic = require("../store/actions/traffic");

var _actions = require("./actions");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Conversation =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Conversation, _PureComponent);

  function Conversation() {
    _classCallCheck(this, Conversation);

    return _possibleConstructorReturn(this, _getPrototypeOf(Conversation).apply(this, arguments));
  }

  _createClass(Conversation, [{
    key: "render",
    value: function render() {
      var _this = this;

      var conversation = this.props.conversation;
      return _react["default"].createElement(_react.Fragment, null, conversation.map(function (item, index) {
        item.index = index;
        var lastItem = conversation[index - 1];
        var difference = lastItem ? item.timestamp - lastItem.timestamp : 0;
        var shouldShowTimestamp = !lastItem || difference > 300000; // 30000 ms = 5 min

        var botAction = null;

        switch (item.type) {
          case _constants.CONVERSATION_TYPE_WELCOME:
            botAction = _react["default"].createElement(_actions.Welcome, null);
            break;

          case _constants.CONVERSATION_TYPE_TEXT_BOT:
          case _constants.CONVERSATION_TYPE_TEXT_HUMAN:
            botAction = _react["default"].createElement(_actions.Text, item);
            break;

          case _constants.CONVERSATION_TYPE_TEXT_HUMAN_END:
          case _constants.CONVERSATION_TYPE_TEXT_HUMAN_LEAVE:
            botAction = _react["default"].createElement(_actions.AgentEnded, item);
            break;

          case _constants.CONVERSATION_TYPE_TEXT_HUMAN_START:
          case _constants.CONVERSATION_TYPE_TEXT_HUMAN_JOIN:
            botAction = _react["default"].createElement(_actions.AgentWelcome, item);
            break;

          case _constants.CONVERSATION_TYPE_WAIT_FOR_HUMAN:
            botAction = _react["default"].createElement(_actions.AgentWait, item);
            break;

          case _constants.CONVERSATION_TYPE_DIAG_BOT:
            botAction = _react["default"].createElement(_actions.Diagnostics, item);
            break;

          case _constants.CONVERSATION_TYPE_BUTTONS:
            if (index === conversation.length - 1) {
              _this.props.trafficBotActionButtonView(item.items);

              botAction = _react["default"].createElement(_actions.Buttons, item);
            }

            break;

          case _constants.CONVERSATION_TYPE_UTTERANCE:
            botAction = _react["default"].createElement(_actions.Utterance, item);
            break;

          default:
            botAction = null;
        }

        return _react["default"].createElement(_react.Fragment, {
          key: index
        }, item.type === _constants.CONVERSATION_TYPE_WELCOME && _react["default"].createElement(_actions.Welcome, null), shouldShowTimestamp && _react["default"].createElement(_actions.Timestamp, {
          timestamp: item.timestamp
        }), item.type !== _constants.CONVERSATION_TYPE_WELCOME && _react["default"].createElement("div", {
          className: "jsx-1513594532" + " " + ((0, _classnames["default"])('dialog-message-container', item.type === _constants.CONVERSATION_TYPE_BUTTONS ? 'dialog-message-buttons' : '', item.shown || item.type === _constants.CONVERSATION_TYPE_DIAG_BOT ? '' : 'help--slide-in-up') || "")
        }, botAction));
      }), _react["default"].createElement(_style["default"], {
        id: "1513594532"
      }, ".dialog-message-container.jsx-1513594532{margin-bottom:10px;}.dialog-message-buttons.jsx-1513594532{margin-top:6px;}"));
    }
  }]);

  return Conversation;
}(_react.PureComponent);

Conversation.propTypes = {
  conversation: _conversation.conversationPropTypes.base,
  trafficBotActionButtonView: _propTypes["default"].func
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    conversation: (0, _conversation2.getConversation)(state)
  };
};

var mapDispatchToProps = {
  trafficBotActionButtonView: _traffic.trafficBotActionButtonView
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Conversation);

exports["default"] = _default;